(function(){
  if(window.rlPeek) return;
  window.rlPeek = true;

  var OFFSET = 28;
  var EASE = 0.12;
  var TILT_PER_PX = 0.16;
  var TILT_MAX = 16;
  var STIFF = 0.062;
  var DAMP = 0.87;
  var SKEW = 0.34;

  function init(){
    if(window.matchMedia('(hover: none)').matches) return;
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var links = document.querySelectorAll('[data-peek]');
    if(!links.length) return;

    var box = document.querySelector('.rl-peek');
    if(!box){
      box = document.createElement('div');
      box.className = 'rl-peek';
      box.innerHTML = '<img alt="">';
      document.body.appendChild(box);
    }
    var img = box.querySelector('img');

    var tx = 0, ty = 0, cx = 0, cy = 0;
    var tilt = 0, tv = 0;
    var on = false, raf = null;

    function place(){
      var w = box.offsetWidth, h = box.offsetHeight;
      var x = cx - w / 2;
      var y = cy - h - OFFSET;
      if(y < 12) y = cy + OFFSET;
      if(x < 12) x = 12;
      if(x + w > window.innerWidth - 12) x = window.innerWidth - w - 12;
      box.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0) rotate(' + tilt.toFixed(2) + 'deg) skewX(' + (tilt * SKEW).toFixed(2) + 'deg)';
    }

    function loop(){
      var px = cx;
      cx += (tx - cx) * EASE;
      cy += (ty - cy) * EASE;

      var vx = cx - px;
      var want = Math.max(-TILT_MAX, Math.min(TILT_MAX, -vx * TILT_PER_PX));

      tv += (want - tilt) * STIFF;
      tv *= DAMP;
      tilt += tv;

      place();

      var resting = !on
        && Math.abs(tx - cx) < 0.3
        && Math.abs(ty - cy) < 0.3
        && Math.abs(tilt) < 0.04
        && Math.abs(tv) < 0.04;

      if(resting){ raf = null; } else { raf = requestAnimationFrame(loop); }
    }

    function move(e){
      tx = e.clientX;
      ty = e.clientY;
      if(!raf) raf = requestAnimationFrame(loop);
    }

    links.forEach(function(link){
      var src = link.getAttribute('data-peek');
      if(!src) return;
      var pre = new Image();
      pre.src = src;

      link.addEventListener('mouseenter', function(e){
        img.src = src;
        tx = cx = e.clientX;
        ty = cy = e.clientY;
        tilt = 0;
        tv = 0;
        on = true;
        place();
        box.classList.add('rl-peek--on');
        if(!raf) raf = requestAnimationFrame(loop);
      });
      link.addEventListener('mousemove', move);
      link.addEventListener('mouseleave', function(){
        on = false;
        box.classList.remove('rl-peek--on');
        if(!raf) raf = requestAnimationFrame(loop);
      });
    });

    window.addEventListener('resize', place);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
